import { currencyFormatter } from '../components/shared/numberFormat';
import type { AccountBalance, AccountType, Currency } from '../generated-types';

const formatter = (currency: Currency, hideDecimals: boolean) => (number: number) =>
    currencyFormatter(number, currency, hideDecimals ? 0 : undefined);

export const getBalanceNumbers = (balance: AccountBalance, accountType: AccountType): number[] => {
    if (accountType === 'BSU' || accountType === 'BSU_PLUSS') {
        return [balance.accountingBalance];
    }
    if (balance.creditLimit < 0) {
        return [balance.accountingBalance];
    }
    if (balance.accountingBalance !== balance.availableBalance) {
        return [balance.availableBalance, balance.accountingBalance];
    }
    return [balance.availableBalance];
};

const getBalances = (
    balance: AccountBalance,
    currency: Currency,
    accountType: AccountType,
    hideDecimals: boolean,
): string[] => {
    const cFormatter = formatter(currency, hideDecimals);
    return getBalanceNumbers(balance, accountType).map(cFormatter);
};

export default getBalances;
